// import gsap from "gsap";
import { variables } from "./components/variables";
import Choices from "choices.js";
import Swiper from "swiper";
import { FreeMode, Mousewheel } from "swiper/modules";
import 'swiper/css';

(function($) {


    let screen_width = $(window).width();
    $(window).on('resize', () => screen_width = $(window).width());


    /**
     * Select Dropdowns
     */
    const $selects = $('select');
    $selects.each(function(){
        // Handle tab selects only on mobile
        if ( $(this).hasClass('bde-tabs__select') && screen_width > variables.largeTabletBreakpoint ) {
            return;
        }

        const choices = new Choices($(this)[0], {
            allowHTML: true,
            searchEnabled: false,
            shouldSort: false,
            itemSelectText: ""
        });

        // Update FormStack dropdown / lookup fields
        $(this).on('change', function() {
            $(document).trigger('formSelectChange');
        })
        $(document).on('formSelectChange', function() {
            setTimeout(function(){
                choices.refresh();
            }, 300);
        })
    });
    

    /**
     * Horizontal scrolls on tables
     */
    const $tables = $('.onaTable');
    $tables.each(function(){
        const $table = $(this);
        const $wrapper = $table.parents('.onaTable__wrapper');
        const $inner = $table.parents('.onaTable__inner');
        const $topScroller = $wrapper.find('.onaTable__topScroller');
        const $topScrollerInner = $topScroller.children('div');
        let tableWidth = $table.width();

        tableWidth = adjustTableScroller($table, $topScrollerInner);
        $(window).on('resize', () => adjustTableScroller($table, $topScrollerInner));

        $topScroller.on('scroll', function () {
            $inner.scrollLeft($topScroller.scrollLeft());
            checkTableScrollPercentage($inner, tableWidth, $wrapper);
        });
        $inner.on('scroll', function () {
            $topScroller.scrollLeft($inner.scrollLeft());
            checkTableScrollPercentage($inner, tableWidth, $wrapper);
        });

    });

    function adjustTableScroller($table, $scroller) {
        const tableWidth = $table.width();
        $scroller.width(tableWidth);
        return tableWidth;
    }

    function checkTableScrollPercentage($inner, tableWidth, $wrapper) {
        let scrollPercentage;
        const finishedClass = 'onaTable__wrapper--end';
        scrollPercentage = 100 * $inner.scrollLeft() / (tableWidth - $inner.width());
        if ( scrollPercentage == 100 ) {
            $wrapper.addClass(finishedClass);
        } else if ($wrapper.hasClass(finishedClass)) {
            $wrapper.removeClass(finishedClass);
        }
    }


    /**
     * Accessibility Fix: Add aria-label to links opening in a new tab/window
     */
    $('a[target="_blank"]').each(function() {
        const text = $(this).text().trim();
        $(this).attr('aria-label', text + ', opens in a new window');
    });

    /**
     * Accessibility Fix: Tag popup buttons with role="button"
     */
    $('.breakdance-link[data-type="action"]').each(function() {
        $(this).attr('role', 'button');
    });
    $('.breakdance-popup-close-button').each(function() {
        $(this).attr('role', 'button');
        $(this).attr('tabindex', '0');
    });

    /**
     * Accessibility Fix: Add text or labels to empty buttons
     */
    $('#searchBtn a.breakdance-link').each(function(){
        $(this).attr('aria-label', 'Open Search');
    });

    $('.breakdance-popup-close-button').each(function(){
        $(this).attr('aria-label', 'Close Popup');
    });

    /**
     * Accessibility Fix: 
     * - Menu items that have a dropdown should include an aria-haspopup="true" attribute
     * - Dropdown expanded/collapsed state should be represented in the code
     */
    $('.breakdance-dropdown, .glink').each(function() {
        $(this).attr('aria-haspopup', 'true');
        $(this).attr('aria-expanded', 'false');
    });
    $('.breakdance-dropdown, .glink').on('mouseenter focusin', function() {
        $(this).attr('aria-expanded', 'true');

    });
    $('.breakdance-dropdown, .glink').on('mouseleave focusout', function() {
        $(this).attr('aria-expanded', 'false');
    });



    /**
     * Article: Position breakout content on desktop
     */
    calculateBreakouts();
    $(window).on('resize', calculateBreakouts);
    function calculateBreakouts() {
        const $breakouts = $('.bde-preset-a0eef25c-b026-47fe-98d9-bf1be9e6f34f');

        // New layout: Center aligned copy
        const $wrapper = $('.articleMain');
        const $content = $('.articleCentered');
        if ( $breakouts.length && $wrapper.length && $content.length ) {
            if ( $(window).width() > 1119 ) {
                $breakouts.addClass('breakout--pushed');
    
                const fullWidth = $wrapper.find('.section-container').width();
                $breakouts.css('width', fullWidth + 'px');
        
                const contentWidth = $content.outerWidth();
                const pushAmount = (fullWidth - contentWidth) / 2;
                $breakouts.css('transform', 'translateX(-' + pushAmount + 'px)');
                
            } else {
                $breakouts.removeClass('breakout--pushed');
                $breakouts.css('width', '100%');
                $breakouts.css('transform', 'none');
            }
        }

        // Old layout: Left aligned copy
        const $columns = $('.articleColumns');
        const $sidebar = $('.articleSidebar');
        if ( $breakouts.length && $columns.length && $sidebar.length ) {
            if ( $(window).width() > 1119 ) {
                $breakouts.addClass('breakout--pushed');
    
                const fullWidth = $columns.outerWidth();
                $breakouts.css('width', fullWidth + 'px');
        
                const sidebarWidth = $sidebar.outerWidth();
                let columnsGap = getComputedStyle($columns[0]).columnGap;
                if ( !columnsGap ) return;
                columnsGap = parseInt(columnsGap, 10);
                const pushAmount = sidebarWidth + columnsGap;
                $breakouts.css('transform', 'translateX(-' + pushAmount + 'px)');
                
            } else {
                $breakouts.removeClass('breakout--pushed');
                $breakouts.css('width', '100%');
                $breakouts.css('transform', 'none');
            }
            
        }
    }


    /**
     * Article Sliders
     */
    const articleSlidersArgs = {
        modules: [FreeMode, Mousewheel],
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesOffsetBefore: 20,
        slidesOffsetAfter: 20,
        freeMode: {
            enabled: true
        },
        mousewheel: {
            enabled: true,
            forceToAxis: true
        },
        breakpoints: {
            479: {
                slidesOffsetBefore: 30,
                slidesOffsetAfter: 30
            },
            768: {
                slidesOffsetBefore: 50,
                slidesOffsetAfter: 50
            },
            1119: {
                slidesOffsetBefore: 100,
                slidesOffsetAfter: 100
            },
            1700: {
                slidesOffsetBefore: 150,
                slidesOffsetAfter: 150
            }
          }
      };

    const $articleSliders = $('.articleSlider');
    $articleSliders.each(function(){
        const swiper = new Swiper($(this)[0], articleSlidersArgs);
    });



    /**
     * Article Sliders with ALM integration
     * When the trigger load value has been reached/surpassed, send a load click to the ALM instance
     */
    const $articleSlidersALM = $('.articleSliderALM');
    $articleSlidersALM.each(function(){
        // Find elements
        const $swiperWrapper = $(this).find('.ajax-load-more-wrap');
        const $scrollbar = $(this).find('.swiper-scrollbar');

        // Enable Slider
        const swiper = new Swiper($swiperWrapper[0], articleSlidersArgs);
        const almInstance = $(this).find('.ajax-load-more-wrap').data('id');
        const triggerLoadValue = 0.95;
        let loadingPosts = false;
        let remainingArticles = ''; 

        // Get the amount of articles remaining, reset load flag, and update the slider instance after each successful ALM query
        $(window).on('almSlidersComplete', function(event, alm) {
            if ( alm.id !== almInstance ) return;
            remainingArticles = alm.totalposts - alm.postcount;
            loadingPosts = false;
            swiper.update();
            setTimeout(function(){
                swiper.updateSlides();
            }, 500);
        });


        // When over the progress value, if we have articles left to load AND if we're not already trying to load posts, send a new load query to ALM
        swiper.on('progress', function (swiper, progress) {
            if  ( remainingArticles === 0 || progress < triggerLoadValue || loadingPosts ) return;
            loadingPosts = true;
            ajaxloadmore.click(almInstance);
          });
    });

    window.almComplete = function(alm){
        $(window).trigger('almSlidersComplete', alm);
    };



    /**
     * Gallery Sliders
     */
    const $gallerySliders = $('.gallerySlider');
    $gallerySliders.each(function(){
        const swiper = new Swiper($(this)[0], {
            modules: [FreeMode, Mousewheel],
            slidesPerView: 'auto',
            spaceBetween: 25,
            freeMode: {
                enabled: true
            },
            mousewheel: {
                enabled: true,
                forceToAxis: true
            },
            breakpoints: {
                480: {
                    spaceBetween: 25
                },
                768: {
                    spaceBetween: 25
                },
                1023: {
                    spaceBetween: 50
                }
            },
            on: {
                resize: function (swiper) {
                    // Change slide width to match the width of the content image
                    const slides = swiper.slides;
                    slides.forEach((slide) => {
                        $(slide).width('auto');
                        const img = slide.firstChild;
                        const imgWidth = $(img).width();
                        if ( imgWidth && imgWidth > 0 ) {
                            $(slide).width(imgWidth);
                        }
                    });
                }
            }
          });
    });


    /**
     * On mobile, add full names to language translation widget in the menu
     */
    function adjustMobileTranslateLinks() {
        const $links = $('.breakdance-menu-list .glink');
        $links.each(function(){
            const lang = $(this).data('gt-lang');
            let text = $(this).text();
            switch (lang) {
                case 'en':
                    text = 'English';
                    break;
                case 'fr':
                    text = 'Français';
                    break;
            }
            $(this).text(text);
        });
    }
    setTimeout(adjustMobileTranslateLinks, 500);

	
})( jQuery );

